import routes from 'routes'
import { RouteProps } from 'types'
import { _ } from 'utils/localization'
import { IconOption } from '../../Icon'

interface MenuItem {
    title: string,
    icon?: IconOption,
    route?: RouteProps,
    searchParams?: string
    spaces?: 'booth' | 'normal'
}

export interface SidebarItem extends MenuItem{
    subMenu?: MenuItem[]
    excludeFromLite?: boolean
}

// Change to function to fix issue when initializing app, the routes isn't available
export const sidebarConfigs: () => SidebarItem[] = () => [
    {
        title: routes.gdpr.title,
        icon: 'shieldCheck',
        route: routes.gdpr,
    },
    {
        title: routes.generalSettings.title,
        icon: 'cog',
        route: routes.generalSettings,
    },
    {
        title: _('portal_menu.spaces', {}, false),
        icon: 'buffer',
        spaces: 'normal',
        subMenu: [
            {
                title: routes.spacesOverview.title,
                route: routes.spacesOverview,
            }
        ]
    },
    {
        title: routes.navigation.title,
        icon: 'navigation',
        route: routes.navigation
    },
    {
        title: routes.boothList.title,
        icon: 'store',
        route: routes.boothList,
        spaces: 'booth',
        excludeFromLite: true,
    },
    {
        title: routes.showList.title,
        icon: 'clock',
        route: routes.showList,
    },
    {
        title: routes.speakerList.title,
        icon: 'microphone',
        route: routes.speakerList,
    },
    {
        title: routes.attendees.title,
        icon: 'group',
        route: routes.attendees,
    },
    {
        title: routes.eventAdmins.title,
        icon: 'accountCheck',
        route: routes.eventAdmins,
    },
    {
        title: routes.groupSessions.title,
        icon: 'accountMultiple',
        route: routes.groupSessions,
        excludeFromLite: true,
    },
]

const getPortalSidebarConfig = (isLiteVersion: boolean) => sidebarConfigs().filter(
    (config) => !isLiteVersion || !config.excludeFromLite
)

const boothSidebarConfig: () => Record<string, SidebarItem> = () => ({
    editBooth: {
        title: routes.editBooth.title,
        icon: 'cog',
        route: routes.editBooth,
    },
    boothCrew: {
        title: routes.boothCrew.title,
        icon: 'accountCircle',
        route: routes.boothCrew,
    },
    boothJobs: {
        title: routes.boothJobs.title,
        icon: 'group',
        route: routes.boothJobs,
    },
})

const getBoothSidebarConfig = (allowJobs): SidebarItem[] => {
    const exclude = allowJobs ? [] : ['boothJobs']
    return Object.entries(boothSidebarConfig())
        .filter(([key]) => !exclude.includes(key))
        .map(([, value]) => value)
}

const getSidebarConfig = (isBooth = false, isLiteVersion = false, allowJobs = true) => (
    isBooth
        ? getBoothSidebarConfig(allowJobs)
        : getPortalSidebarConfig(isLiteVersion)
)

export default getSidebarConfig
